import React from 'react';

import { StyledTitleContent } from './TitleContent.styles';

import { TitleContentProps } from './TitleContent.types';

const TitleContent = ({
  isSection = false,
  title,
  children,
  additionalContent,
  componentClassname = 'title-content',
  customClassnames = '',
  customStyle = '',
}: TitleContentProps) => {
  if (!title || !children) {
    return null;
  }

  return (
    <StyledTitleContent
      as={isSection ? 'section' : 'div'}
      className={`${componentClassname} ${customClassnames} ${
        isSection ? `${componentClassname}--is-section` : ''
      }`}
      customStyle={customStyle}
    >
      <div className={`${componentClassname}__title-line`}>
        <div className={`${componentClassname}__title`}>{title}</div>
        {additionalContent && (
          <div className={`${componentClassname}__additional-content`}>
            {additionalContent}
          </div>
        )}
      </div>
      <div className={`${componentClassname}__content`}>{children}</div>
    </StyledTitleContent>
  );
};

export default TitleContent;
